/* tbh-wishlist.js (2026-11-04, Sampath; item 13, option A of claude.ai/artifact/6eqYUQADiP8ZNrqmuGmAh6,
   "list in the account too").
   - Hearts (snippets/tbh-wish-btn.liquid) on product cards and beside the product title; the header heart
     (snippets/tbh-wish-head.liquid) shows the count and leads to /pages/wishlist (the customer's word is WISHLIST, Sampath 2026-11-04).
   - The list lives in this browser (localStorage 'tbh-wish': [{h: handle, c: colour ('' if none),
     v: variant id hearted, p: price in paise when saved, at: ms}]), ONE ITEM PER PRODUCT AND COLOUR, so
     the Wishlist page shows the colour that was hearted (its photo, its sizes, its price). For a SIGNED-IN customer it is also kept in the account through the club app's
     proxy, /apps/club/wishlist (bike-affair-delivery src/lib/wishlist.js): the first page of a visit
     sends this browser's list to join the account one, every heart sends its change, and the answer
     (the whole list) replaces the local copy. If the proxy does not answer, the local list still works.
   - The Saved page (sections/tba-saved.liquid) is drawn here from /products/<handle>.js: price now,
     "₹X lower since you added it", "Only size L left", sold out with a link to similar products,
     Add to cart (a size list when there is more than one in stock), Remove. */
(function () {
  'use strict';
  var KEY = 'tbh-wish';
  var signedIn = !!(window.tbhShopper && window.tbhShopper.signedIn);

  function read() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, 100))); } catch (e) {} }
  function key(h, c) { return h + '|' + String(c || '').toLowerCase(); }

  function paint() {
    var list = read(), set = {};
    list.forEach(function (x) { set[key(x.h, x.c)] = 1; });
    document.querySelectorAll('[data-tbh-wish]').forEach(function (b) {
      var on = !!set[key(b.getAttribute('data-tbh-wish'), b.getAttribute('data-c'))];
      if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', on);
    });
    document.querySelectorAll('[data-tbh-wish-count]').forEach(function (c) {
      c.textContent = list.length > 99 ? '99+' : list.length;
      c.hidden = list.length === 0;
    });
  }

  function server(change) {
    if (!signedIn) return Promise.resolve(null);
    var opts = change
      ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(change), credentials: 'same-origin' }
      : { credentials: 'same-origin' };
    return fetch('/apps/club/wishlist', opts)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (d && d.signed_in && Array.isArray(d.items)) { write(d.items); paint(); window.dispatchEvent(new CustomEvent('tbh:wish-changed')); }
        return d;
      })
      .catch(function () { return null; });
  }

  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'tbh-wish-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2400);
  }

  function toggle(b) {
    var h = b.getAttribute('data-tbh-wish'), c = b.getAttribute('data-c') || '';
    var k = key(h, c);
    var list = read();
    var on = !list.some(function (x) { return key(x.h, x.c) === k; });
    if (on) {
      var item = { h: h, c: c, v: b.getAttribute('data-v') || null, p: Number(b.getAttribute('data-p')) || null, at: Date.now() };
      list.unshift(item);
      write(list);
      server({ add: [item] });
      toast('Added to your wishlist');
    } else {
      write(list.filter(function (x) { return key(x.h, x.c) !== k; }));
      server({ remove: [{ h: h, c: c }] });
      toast('Removed from your wishlist');
    }
    paint();
    window.dispatchEvent(new CustomEvent('tbh:wish-changed'));
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-tbh-wish]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(b);
  }, true);

  /* Cards arrive later (filters, load more, carousels, the search page): paint them as they come. */
  var pending;
  if (window.MutationObserver) {
    new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(paint, 80); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
  /* The product page heart follows the chosen variant: its colour, id and price. */
  document.addEventListener('on:variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (v) {
      document.querySelectorAll('.tbh-heart--pdp').forEach(function (b) {
        var pos = Number(b.getAttribute('data-cpos')) || 0;
        b.setAttribute('data-v', v.id);
        if (v.price != null) b.setAttribute('data-p', v.price);
        if (pos && v.options) b.setAttribute('data-c', v.options[pos - 1] || '');
      });
    }
    setTimeout(paint, 60);
  });

  /* First page of a visit, signed in: join this browser's list to the account's. */
  function firstSync() {
    var done;
    try { done = sessionStorage.getItem('tbh-wish-synced'); } catch (e) {}
    if (done) return server(null);
    return server({ add: read() }).then(function (d) {
      if (d) { try { sessionStorage.setItem('tbh-wish-synced', '1'); } catch (e) {} }
      return d;
    });
  }

  /* ---------- The Saved page ---------- */
  function rupees(paise) { return '₹' + Math.round(paise / 100).toLocaleString('en-IN'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(src) {
    if (!src) return '';
    src = src.indexOf('//') === 0 ? 'https:' + src : src;
    return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=240';
  }
  function sizeNote(p) {
    var idx = -1;
    (p.options || []).forEach(function (o, i) { var n = typeof o === 'string' ? o : o.name; if (idx < 0 && /size/i.test(n)) idx = i; });
    if (idx < 0) return '';
    var all = {}, inStock = {};
    p.variants.forEach(function (v) { var s = v.options[idx]; all[s] = 1; if (v.available) inStock[s] = 1; });
    var a = Object.keys(all), s = Object.keys(inStock);
    if (a.length < 3 || !s.length || s.length > 2) return '';
    return s.length === 1 ? 'Only size ' + s[0] + ' left' : 'Only ' + s.join(', ') + ' left';
  }
  function addToCart(id, btn) {
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(id), quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        btn.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        setTimeout(function () { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true })); }, 350);
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Add to cart'; toast('That did not go into the cart. Try again.'); });
  }

  function drawSaved(box) {
    var list = read();
    var listEl = box.querySelector('[data-tbh-saved-list]');
    var countEl = box.querySelector('[data-tbh-saved-count]');
    var emptyEl = box.querySelector('[data-tbh-saved-empty]');
    countEl.textContent = list.length ? '(' + list.length + ')' : '';
    if (!list.length) { listEl.innerHTML = ''; emptyEl.hidden = false; box.classList.add('is-ready'); return; }
    emptyEl.hidden = true;
    listEl.setAttribute('aria-busy', 'true');
    Promise.all(list.map(function (it) {
      return fetch('/products/' + encodeURIComponent(it.h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return undefined; })
        .then(function (p) { return { it: it, p: p }; });
    })).then(function (rows) {
      var gone = rows.filter(function (r) { return r.p === null; }).map(function (r) { return r.it.h; });
      if (gone.length) { write(read().filter(function (x) { return gone.indexOf(x.h) < 0; })); server({ remove: gone }); paint(); }
      var html = rows.filter(function (r) { return r.p; }).map(function (r) {
        var p = r.p, it = r.it;
        /* The colour that was hearted: its variants, photo, sizes and price. */
        var cpos = -1;
        (p.options || []).forEach(function (o, i) { var n = typeof o === 'string' ? o : o.name; if (cpos < 0 && /colou?r/i.test(n)) cpos = i; });
        var mine = p.variants;
        if (it.c && cpos >= 0) {
          var want = String(it.c).toLowerCase();
          var same = p.variants.filter(function (v) { return String(v.options[cpos]).toLowerCase() === want; });
          if (same.length) mine = same;
        }
        var hearted = null;
        p.variants.forEach(function (v) { if (String(v.id) === String(it.v)) hearted = v; });
        var shown = (hearted && mine.indexOf(hearted) >= 0) ? hearted : mine[0];
        var photo = (shown && shown.featured_image && shown.featured_image.src) || '';
        if (!photo) mine.forEach(function (v) { if (!photo && v.featured_image) photo = v.featured_image.src; });
        photo = photo || p.featured_image;
        var url = '/products/' + p.handle + (shown ? '?variant=' + shown.id : '');
        var avail = mine.filter(function (v) { return v.available; });
        var colourName = (it.c && cpos >= 0 && mine !== p.variants) ? mine[0].options[cpos] : '';
        var chips = '';
        if (!avail.length) {
          chips = '<span class="tbh-saved__chip tbh-saved__chip--out">' + (colourName && p.available ? 'Sold out in ' + esc(colourName) : 'Sold out') + '</span>';
        } else {
          var low = avail.reduce(function (m, v) { return Math.min(m, v.price); }, Infinity);
          if (it.p && low < it.p) chips += '<span class="tbh-saved__chip tbh-saved__chip--down">' + rupees(it.p - low) + ' lower since you added it</span>';
          var sn = sizeNote({ options: p.options, variants: mine });
          if (sn) chips += '<span class="tbh-saved__chip tbh-saved__chip--low">' + esc(sn) + '</span>';
        }
        var price = avail.length ? rupees(avail.reduce(function (m, v) { return Math.min(m, v.price); }, Infinity)) : '';
        var act;
        if (!avail.length && p.available) {
          act = '<a class="tbh-saved__similar" href="/products/' + p.handle + '">See other colours</a>';
        } else if (!avail.length) {
          act = '<a class="tbh-saved__similar" href="/search?q=' + encodeURIComponent(p.type || p.title) + '">See similar products</a>';
        } else if (avail.length === 1) {
          act = '<button type="button" class="tbh-saved__add" data-add="' + avail[0].id + '">Add to cart</button>';
        } else {
          act = '<label class="visually-hidden" for="tbh-sv-' + p.id + '">Choose</label><select class="tbh-saved__pick" id="tbh-sv-' + p.id + '">' +
            avail.map(function (v) { return '<option value="' + v.id + '"' + (hearted && v.id === hearted.id ? ' selected' : '') + '>' + esc(v.title) + ' · ' + rupees(v.price) + '</option>'; }).join('') +
            '</select><button type="button" class="tbh-saved__add" data-add-pick="tbh-sv-' + p.id + '">Add to cart</button>';
        }
        return '<li class="tbh-saved__row' + (avail.length ? '' : ' is-out') + '">' +
          '<a class="tbh-saved__img" href="' + url + '" tabindex="-1" aria-hidden="true">' + (photo ? '<img src="' + esc(img(photo)) + '" alt="" loading="lazy" width="120" height="120">' : '') + '</a>' +
          '<div class="tbh-saved__info"><a class="tbh-saved__title" href="' + url + '">' + esc(p.title) + '</a>' +
          (colourName ? '<span class="tbh-saved__colour">' + esc(colourName) + '</span>' : '') +
          (price ? '<span class="tbh-saved__price">' + price + '</span>' : '') +
          (chips ? '<span class="tbh-saved__chips">' + chips + '</span>' : '') +
          '<div class="tbh-saved__act">' + act + '<button type="button" class="tbh-saved__remove" data-remove="' + esc(p.handle) + '" data-rc="' + esc(it.c || '') + '">Remove</button></div></div></li>';
      }).join('');
      listEl.innerHTML = html;
      listEl.removeAttribute('aria-busy');
      countEl.textContent = read().length ? '(' + read().length + ')' : '';
      emptyEl.hidden = read().length > 0;
      box.classList.add('is-ready');
    });
  }
  function savedPage() {
    var box = document.querySelector('[data-tbh-saved]');
    if (!box) return;
    box.addEventListener('click', function (e) {
      var a = e.target.closest('[data-add]');
      if (a) return addToCart(a.getAttribute('data-add'), a);
      var ap = e.target.closest('[data-add-pick]');
      if (ap) return addToCart(document.getElementById(ap.getAttribute('data-add-pick')).value, ap);
      var rm = e.target.closest('[data-remove]');
      if (rm) {
        var h = rm.getAttribute('data-remove'), rc = rm.getAttribute('data-rc') || '';
        write(read().filter(function (x) { return key(x.h, x.c) !== key(h, rc); }));
        server({ remove: [{ h: h, c: rc }] });
        paint();
        var row = rm.closest('.tbh-saved__row');
        if (row) row.remove();
        box.querySelector('[data-tbh-saved-count]').textContent = read().length ? '(' + read().length + ')' : '';
        box.querySelector('[data-tbh-saved-empty]').hidden = read().length > 0;
      }
    });
    drawSaved(box);
    var redraw;
    window.addEventListener('tbh:wish-changed', function () { clearTimeout(redraw); redraw = setTimeout(function () { drawSaved(box); }, 50); });
  }

  function start() { paint(); savedPage(); firstSync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
